<template>
    <div class="fixturesWrap">
        <p class="tableTit clearfix" v-if="!noDataModeShow">
            <span class="first" @click="prevFn" :class="{'prevBtnhidden':!prevBtn}">
                <img class="leftArrow" src="../assets/stats/arrow_left.png">Previous
            </span>
            <span class="second"> {{currentRoundName}}</span>
            <span class="third" @click="nextFn" :class="{'prevBtnhidden':!nextBtn}">Next
                <img class="rightArrow" src="../assets/stats/arrow_right.png">
            </span>
        </p>
        <div class="tableBody">
            <div class="noDataWrap" v-if="noDataMode">
                <img src="../assets/stats/Stats_nulldata.png?v1232">
                <p class="sorry">Sorry , no content yet</p>
            </div>
            <div class="list clearfix" v-for="(item,index) in fixturesMatchData">
                <span class="date">{{tran12(item.finalIneedTime.finalTime_md_hm)}}</span>
                <p class="teamA clearfix"><span class="teamA_name">{{item.team_A_name}}</span><img
                    :src="getImgSrc(item.team_A_logo)" v-team-logo class="teamA_logo"></p>
                <p class="score">
                    <span v-if="item.status === 'Cancelled' || item.status ==='Postponed' || item.status ==='Suspended' || item.status ==='Uncertain'">--</span>
                    <span v-if="item.status === 'Fixture'">VS</span>
                    <span v-if="item.status === 'Played'|| item.status ==='Playing'" :class="{'colorGreen':item.status ==='Playing'}">
                        {{item.fs_A}} : {{item.fs_B}}
                    </span>
                </p>
                <p class="teamB clearfix">
                    <span class="teamB_name">{{item.team_B_name}}</span>
                    <img :src="getImgSrc(item.team_B_logo)" v-team-logo class="teamB_logo">
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: '',
        data: function () {
            return {
                fixturesMatchData: this.fixtures.matches,
                fixturesRoundsData: this.fixtures.rounds,
                currentRoundName: '',
                currentRoundUrl: '',
                currentRoundPrevUrl: '',
                currentRoundNextUrl: '',
                prevBtn: true,
                nextBtn: true,
                indexRound: null,
                fixturesTitShow: true,
                noDataMode: false,
            };
        },
        created: function (){

            let that = this;
            that.prevBtn = true;
            that.nextBtn = true;
            if (typeof this.fixturesMatchData == 'undefined' || this.fixturesMatchData.length === 0) {
                this.fixturesTitShow = false;
            }

            if (typeof this.fixturesRoundsData == 'undefined' || this.fixturesRoundsData.length === 0) {
                // 轮次为空时
                that.prevBtn = false;
                that.nextBtn = false;
            }
            this.fixturesRoundsData &&  this.fixturesRoundsData .length && this.fixturesRoundsData.forEach(function (e, i) {
                if (e.current == true) {
                    that.indexRound = i;
                    that.currentRoundName = e.name;
                    that.currentRoundUrl = e.url;
                    if (i <= 0) {
                        that.prevBtn = false;
                    }
                    if (i >= that.fixturesRoundsData.length - 1) {
                        that.nextBtn = false;
                    }
                }
            });
            this.fixturesMatchData && this.fixturesMatchData.length && this.fixturesMatchData.forEach(function (e, i) {
                let dateTime = e.start_play;
                e.finalIneedTime = that.formatDate(dateTime);
            });
        },
        mounted: function () {

        },
        methods: {
            // 转换成12小时制方法
            tran12 (time) {
                let time_arr = time.split(':');
                if (time_arr[0] > 12) {
                    var result = (time_arr[0] - 12) + ':' + time_arr[1] + ' FM';
                } else {
                    var result = time_arr[0] + ':' + time_arr[1] + ' AM';
                }
                return result;
            },
            formatDate: function (gmtDate) {
                console.log('initial utc data:' + gmtDate);// 2017-08-12 14:00:00
                let date = new Date(gmtDate.replace(/-/g, '/')).getTime();// 获取UTC时间戳
                let diff_min = new Date().getTimezoneOffset();// 返回UTC时间和当前计算机上的时间之间相差的分钟数。utc-当地=差分钟数;
                let local_date = new Date(date - diff_min * 60 * 1000);// 获取当地时间
                // console.log("local_date:"+local_date);//Sat Aug 12 2017 22:00:00 GMT+0800 (+08)
                let local_month = local_date.getMonth() + 1;
                local_month = this.dateToDubble(local_month);
                let local_timeDetail = ('' + local_date).split(' ');
                let local_md_hm = local_month + '-' + local_timeDetail[2] + ' ' + local_timeDetail[4].split(':')[0] + ':' + local_timeDetail[4].split(':')[1];
                console.log('finalTime_md_hm:' + local_md_hm);
                return {
                    finalTime_md_hm: local_md_hm,
                };
            },
            dateToDubble: function (str) {
                if (str < 10) {
                    return '0' + str;
                } else {
                    return str;
                }
            },
            prevFn: function () {
                let that = this;
                that.noDataMode = false;
                console.log('click Prev');
                this.indexRound--;
                that.currentRoundName = this.fixturesRoundsData[this.indexRound].name;
                that.currentRoundUrl = this.fixturesRoundsData[this.indexRound].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
                ;
                console.log(that.currentRoundUrl);
                axios.get(
                    that.currentRoundUrl).then(res => { // 获取二级导航以及默认页面数据
                    if (res.data.content.matches.length === 0) {
                        that.noDataMode = true;
                    } else {
                        that.noDataMode = false;
                    }
                    res.data.content.matches.forEach(function (e, i) {
                        let dateTime = e.start_play;
                        e.finalIneedTime = that.formatDate(dateTime);
                    });
                    that.fixturesMatchData = res.data.content.matches;
                    that.fixturesRoundsData = res.data.content.rounds;
                }, res => {
                    // error callback
                });
                if (this.indexRound <= 0) {
                    console.log('超出隐藏左侧箭头');
                    this.prevBtn = false;
                } else if (this.indexRound > 0 && this.indexRound < this.fixturesRoundsData.length - 1) {
                    this.nextBtn = true;
                }
            },
            nextFn: function () {
                let that = this;
                that.noDataMode = false;
                console.log('click Next');
                this.indexRound++;
                console.log('this.indexRound:');
                console.log(this.indexRound);
                console.log(this.fixturesRoundsData[this.indexRound]);
                that.currentRoundName = this.fixturesRoundsData[this.indexRound].name;
                that.currentRoundUrl = this.fixturesRoundsData[this.indexRound].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
                console.log(that.currentRoundUrl);
                axios.get(global.apiDomain + that.currentRoundUrl).then(res => { // 获取二级导航以及默认页面数据
                    if (res.data.content.matches.length === 0) {
                        that.noDataMode = true;
                    } else {
                        that.noDataMode = false;
                    }
                    res.data.content.matches.forEach(function (e, i) {
                        let dateTime = e.start_play;
                        e.finalIneedTime = that.formatDate(dateTime);
                    });
                    that.fixturesMatchData = res.data.content.matches;
                    that.fixturesRoundsData = res.data.content.rounds;
                    console.log(that.fixturesMatchData);
                    console.log(that.fixturesRoundsData);
                }, res => {
                    // error callback
                });
                if (this.indexRound >= this.fixturesRoundsData.length - 1) {
                    console.log('超出隐藏右侧箭头');
                    this.nextBtn = false;
                    return;
                }
                if (this.indexRound > 0) {
                    this.prevBtn = true;
                }
                console.log(this.indexRound);
            },
        },
        props: ['fixtures', 'noDataModeShow']
    };
</script>
<style lang="less">
    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .clearfix {
        *zoom: 1;
    }

    .clear {
        clear: both;
    }

    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .fixturesWrap {
        height: auto;
        overflow: hidden;
    }

    .fixturesWrap .tableTit {
        height: 1.8rem;
        background: #404c57;
        color: #fff;
        line-height: 1.8rem;
        font-size: .68rem;
    }

    .fixturesWrap .tableTit span {
        display: inline-block;
        font-size: 0.68rem;
    }

    .fixturesWrap .first {
        width: 25%;
        text-align: right;
        float: left;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .fixturesWrap .second {
        width: 50%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-indent: 1rem;
    }

    .fixturesWrap .third {
        width: 25%;
        text-align: left;
        float: right;
        text-indent: 0.5rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .fixturesWrap .tableBody {
        background: #333d46;
    }

    .fixturesWrap .leftArrow {
        width: .3rem;
        margin-right: .3rem;
    }

    .fixturesWrap .rightArrow {
        width: .3rem;
        margin-left: .3rem;
    }

    .fixturesWrap .list {
        font-size: .68rem;
        height: 2.8rem;
        line-height: 2.8rem;
        color: #fff;
        /*border-bottom: 1px solid #2b353d;*/
    }

    .fixturesWrap .date {
        width: 5.8rem;
        color: #929cad;
        text-align: center;
    }

    .fixturesWrap .teamA_name, .fixturesWrap .teamB_name {
        width: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-align: right;
    }

    .fixturesWrap .score {
        width: 1.8rem;
        text-align: center;
    }

    .fixturesWrap .teamA_logo, .fixturesWrap .teamB_logo {
        width: 1.5rem;
        height: auto;
        vertical-align: middle;
        margin: .6rem .3rem 0;
        float: left;
    }

    .fixturesWrap .teamB_name {
        float: right !important;
        text-align: left !important;
    }

    .fixturesWrap .date, .fixturesWrap .teamA, .fixturesWrap .score, .fixturesWrap .teamB {
        float: left;
        height: 2.5rem;
    }

    .fixturesWrap .list span {
        display: inline-block;
    }

    .prevBtnhidden {
        visibility: hidden;
    }

    .noDataWrap {
        width: 100%;
        margin: 0 auto 13.33333333rem;
        padding: 4.4rem 0 3rem;
    }

    .noDataWrap img {
        width: 9.4rem;
        display: block;
        margin: 0 auto;
        height: auto;
    }

    .sorry {
        font-size: .9rem;
        color: #929cad;
        text-align: center;
    }

    .grayColor {
        color: #b5bcc4 !important;
    }

    .colorGreen {
        color: #16ac3a !important;
    }
</style>



// WEBPACK FOOTER //
// fixtures.vue?16b47f21